<template>

  <div class="app-container">
    <template v-if="initialized">
      <div id="app-inner">
        <ParentView />
      </div>
    </template>
    <template v-else>
      <div id="initializing">
        <h5>Application is initializing, please wait...</h5>
      </div>
    </template>
  </div>

</template>

<script>

  import 'bootstrap'
  import 'bootstrap/dist/css/bootstrap.css'

  import axios from 'axios'
  import Utils from '@/utils.js'
  import store from './store'

  import {
    SHOW_APP_ACTION
  } from '@/store-constants.js';

  require('./assets/app.css')

  // import Navigation from '@/components/Navigation.vue';
  import ParentView from '@/views/ParentView.vue'

  export default {
    name: 'app',
    components: {
      ParentView
    },

    data() {
      return {
        initialized: false
      }
    },

    mounted() {
      // this health check is done at the very beginning to,
      // 1. prompt the login page if the jwt token is invalid.
      // 2. to wake up the backend, in case it is asleep.
      axios.get(Utils.getURL('/healthcheck'))
        .then(() => {
          store.dispatch(SHOW_APP_ACTION);
          this.initialized = true;
        })
        .catch(() => {
          store.dispatch(SHOW_APP_ACTION);
          this.initialized = true;
        });
    }
  }

</script>

<style>

  #app-inner {
    /* text-align: center; */
    height: 100%;
    /* background-color: red; */
    /* margin-top: 60px; */
  }

  .app-container {
    background-color: var(--app-background-color);
    height: 100%;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }

  #initializing {
    display: flex;
    background-color: var(--blue-color);
    color: white;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

</style>
